up.compiler('[modal-fragment]', (modalFragment) => {
    const openButton = modalFragment.querySelector('[modal-fragment--button]')
    const template = modalFragment.querySelector('[modal-fragment--template]')

    openButton.addEventListener('click', () => {
        const clonedTemplate = document.importNode(template, true)
        up.layer.open({ fragment: clonedTemplate })
    })
})
